import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";

import Style from "@client/utils/Style";

import DropdownLink from "../DropdownLink";
import Stepper from "../Stepper";
import arrowImage from "./images/arrow";

const Wrapper = styled.div<{ highlight?: boolean; disabled?: boolean }>`
  display: flex;
  align-items: center;
  border: 1px solid
    ${props =>
      props.disabled
        ? Style.palette.grayscale[0]
        : props.highlight
          ? Style.palette.alert
          : Style.palette.grayscale[3]};
  border-radius: ${Style.borderRadius};
  height: ${Style.inputSizes.regular.height - 2}px;
`;
const linkButtonStyle = (props: { disabled?: boolean }) => {
  return {
    width: "70px",
    height: "14px",
    padding: "8px",
    background: props.disabled
      ? Style.palette.grayscale[0]
      : Style.palette.grayscale[1],
    borderTopLeftRadius: Style.borderRadius,
    borderBottomLeftRadius: Style.borderRadius,
    justifyContent: "center",
  };
};
type ItemType = {
  label: string;
  value: string;
  [key: string]: any;
};
type Props = {
  items: ItemType[];
  selectedItem: ItemType;
  onItemChange: (item: ItemType) => void;
  inputValue: number;
  onInputChange: (value: number) => void;
  highlight?: boolean;
  disabled?: boolean;
};
@observer
class StepperDropdownToggle extends React.Component<Props> {
  render() {
    return (
      <Wrapper highlight={this.props.highlight} disabled={this.props.disabled}>
        <DropdownLink
          linkButtonStyle={linkButtonStyle(this.props)}
          items={this.props.items}
          selectedItem={this.props.selectedItem}
          onChange={this.props.onItemChange}
          listWidth="auto"
          secondary
          disabled={this.props.disabled}
          arrowImage={arrowImage}
        />
        <Stepper
          embedded
          width="136px"
          style={{ paddingLeft: "8px", height: "30px" }}
          value={this.props.inputValue}
          onChange={val => {
            this.props.onInputChange(val);
          }}
          disabled={this.props.disabled}
        />
      </Wrapper>
    );
  }
}

export default StepperDropdownToggle;
